(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catagory"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Pre-load lazy images just before they slide into view (native lazy does not
     look inside horizontal scrollers, which caused blank cards). */
  function warm(root, slider) {
    var imgs = Array.prototype.slice.call(slider.querySelectorAll('img[loading="lazy"]'));
    if (!imgs.length) return;
    function load(img) { img.loading = 'eager'; }
    if (!('IntersectionObserver' in window)) { imgs.forEach(load); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
      });
    }, { root: slider, rootMargin: '0px 100% 0px 100%' });

    var gate = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      gate.disconnect();
      imgs.forEach(function (img) { io.observe(img); });
    }, { rootMargin: '600px 0px' });

    gate.observe(root);
  }

  function nav(root, slider) {
    var prev = root.querySelector('[data-tc-prev]');
    var next = root.querySelector('[data-tc-next]');
    var wrap = root.querySelector('.tc-desktop-nav');
    if (!prev || !next) return;

    var ticking = false;
    function update() {
      ticking = false;
      var max = slider.scrollWidth - slider.clientWidth;
      if (wrap) wrap.hidden = max <= 2;
      prev.disabled = slider.scrollLeft <= 2;
      next.disabled = slider.scrollLeft >= max - 2;
    }
    function queue() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    function step(dir) {
      slider.scrollBy({
        left: dir * Math.max(240, slider.clientWidth * 0.82),
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    slider.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(slider);
    update();
  }

  function init(root) {
    if (!root || root.dataset.tcReady === 'true') return;
    root.dataset.tcReady = 'true';
    var slider = root.querySelector('.tc-grid');
    if (!slider) return;
    warm(root, slider);
    nav(root, slider);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.tc-section'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('.tc-section'));
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target;
    var slider = card.closest && card.closest('.tc-grid');
    if (!slider) return;
    Array.prototype.forEach.call(card.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    if (slider.scrollWidth > slider.clientWidth) {
      slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'auto' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEY = 'TimelessFlashSaleController';

  if (window[KEY]) {
    window[KEY].initAll(document);
    return;
  }

  const controller = {
    roots: new Set(),
    observer: null,
    tickId: 0,
    sectionEventsBound: false,

    pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    },

    resolveDeadline(root) {
      const year = Math.max(2026, Number(root.dataset.endYear || 2026));
      const month = Math.min(12, Math.max(1, Number(root.dataset.endMonth || 1)));
      const requestedDay = Math.min(31, Math.max(1, Number(root.dataset.endDay || 1)));
      const hour12 = Math.min(12, Math.max(1, Number(root.dataset.endHour || 12)));
      const minute = Math.min(59, Math.max(0, Number(root.dataset.endMinute || 0)));
      const ampm = String(root.dataset.endAmpm || 'PM').toUpperCase();
      const timezone = String(root.dataset.endTimezone || '+05:00');

      const maxDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
      const day = Math.min(requestedDay, maxDay);

      let hour24 = hour12 % 12;
      if (ampm === 'PM') hour24 += 12;

      const iso =
        `${year}-${this.pad(month)}-${this.pad(day)}` +
        `T${this.pad(hour24)}:${this.pad(minute)}:00${timezone}`;

      const parsed = Date.parse(iso);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    resolveClockOffset(root) {
      const serverSeconds = Number(root.dataset.serverNow || 0);
      const serverMs = serverSeconds > 0 ? serverSeconds * 1000 : 0;
      return serverMs > 0 ? serverMs - Date.now() : 0;
    },

    now(root) {
      return Date.now() + Number(root._tfsClockOffset || 0);
    },

    render(root) {
      const nodes = root._tfsNodes;
      if (!nodes?.timer) {
        root._tfsActive = false;
        return;
      }

      const remaining = Math.max(0, root._tfsDeadline - this.now(root));

      if (remaining <= 0) {
        if (root.dataset.hideExpired === 'true') {
          root.hidden = true;
          root._tfsActive = false;
          return;
        }

        nodes.timer.hidden = true;

        if (nodes.expired) {
          nodes.expired.hidden = false;
          nodes.expired.textContent = root.dataset.expiredMessage || 'SALE ENDED';
        }

        root._tfsActive = false;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const next = [days, hours, minutes, seconds];
      const previous = root._tfsLast || [];

      if (nodes.days && next[0] !== previous[0]) nodes.days.textContent = this.pad(next[0]);
      if (nodes.hours && next[1] !== previous[1]) nodes.hours.textContent = this.pad(next[1]);
      if (nodes.minutes && next[2] !== previous[2]) nodes.minutes.textContent = this.pad(next[2]);
      if (nodes.seconds && next[3] !== previous[3]) nodes.seconds.textContent = this.pad(next[3]);

      root._tfsLast = next;
    },

    tick() {
      this.tickId = 0;
      let hasActive = false;

      this.roots.forEach((root) => {
        if (!root.isConnected) {
          this.roots.delete(root);
          return;
        }

        if (!root._tfsActive) return;

        this.render(root);
        if (root._tfsActive) hasActive = true;
      });

      if (hasActive) {
        const firstActive = [...this.roots].find((root) => root._tfsActive);
        const clockNow = firstActive ? this.now(firstActive) : Date.now();
        const delay = Math.max(250, 1010 - (clockNow % 1000));
        this.tickId = window.setTimeout(() => this.tick(), delay);
      }
    },

    ensureTicking() {
      if (this.tickId) return;
      this.tick();
    },

    ensureObserver() {
      if (this.observer || !('IntersectionObserver' in window)) return this.observer;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const root = entry.target;
          root._tfsActive = entry.isIntersecting;

          if (entry.isIntersecting) {
            this.render(root);
            this.ensureTicking();
          }
        });
      }, {
        root: null,
        rootMargin: '80px 0px',
        threshold: 0
      });

      return this.observer;
    },

    initRoot(root) {
      if (!root || root.dataset.tfsReady === 'true') return;

      root.dataset.tfsReady = 'true';

      const timer = root.querySelector('[data-tfs-timer]');
      if (!timer) return;

      root._tfsNodes = {
        timer,
        days: root.querySelector('[data-tfs-days]'),
        hours: root.querySelector('[data-tfs-hours]'),
        minutes: root.querySelector('[data-tfs-minutes]'),
        seconds: root.querySelector('[data-tfs-seconds]'),
        expired: root.querySelector('[data-tfs-expired]')
      };

      root._tfsClockOffset = this.resolveClockOffset(root);
      root._tfsDeadline = this.resolveDeadline(root);
      root._tfsActive = true;

      this.roots.add(root);
      this.render(root);

      const observer = this.ensureObserver();

      if (observer) {
        root._tfsActive = false;
        observer.observe(root);
      } else {
        this.ensureTicking();
      }
    },

    initAll(scope = document) {
      if (scope?.matches?.('[data-tfs-root]')) {
        this.initRoot(scope);
      }

      scope?.querySelectorAll?.('[data-tfs-root]').forEach((root) => {
        this.initRoot(root);
      });

      if (!this.sectionEventsBound) {
        this.sectionEventsBound = true;

        document.addEventListener('shopify:section:load', (event) => {
          this.initAll(event.target);
        });

        document.addEventListener('shopify:section:unload', (event) => {
          const roots = event.target?.matches?.('[data-tfs-root]')
            ? [event.target]
            : [...(event.target?.querySelectorAll?.('[data-tfs-root]') || [])];

          roots.forEach((root) => {
            this.observer?.unobserve(root);
            this.roots.delete(root);
            delete root._tfsNodes;
            delete root._tfsLast;
            delete root._tfsDeadline;
            delete root._tfsClockOffset;
            delete root._tfsActive;
          });
        });
      }
    }
  };

  window[KEY] = controller;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => controller.initAll(document), { once: true });
  } else {
    controller.initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
